module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.f041c966.ttf";